export const SET_ORGANISATION_PENSION_SCHEMES =
  'pensionScheme/SET_ORGANISATION_PENSION_SCHEMES';
export const SET_PAGINATION_META = 'pensionScheme/SET_PAGINATION_META';
export const SET_FILTER_PENSION_SCHEMES =
  'pensionScheme/SET_FILTER_PENSION_SCHEMES';
export const SET_CLIENT_APPLIED_FILTER =
  'pensionScheme/SET_CLIENT_APPLIED_FILTER';
